module.exports = ":host {\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center; }\n"